import { render } from "./ArticleEditor.vue?vue&type=template&id=1271a331"
import script from "./ArticleEditor.vue?vue&type=script&lang=js"
export * from "./ArticleEditor.vue?vue&type=script&lang=js"
script.render = render

export default script